import { Alert, CircularProgress } from '@mui/material';

interface FormLoadingMessageProps {
  message: string;
}

function FormLoadingMessage(props: FormLoadingMessageProps) {
  const { message } = props;

  return (
    <Alert
      icon={<CircularProgress size="1.5rem" sx={{ color: 'common.white' }} />}
      sx={{
        backgroundColor: 'success.light',
        color: 'primary.contrastText',
      }}
      variant="filled"
      severity="info"
    >
      {message}
    </Alert>
  );
}

export default FormLoadingMessage;
